import axios from 'axios';

import { env } from '@/env';
import { userManager } from '@/lib/fusionauth';

export const GlobalApiClient = axios.create({
  baseURL: env.VITE_GLOBAL_API_URL || 'http://localhost:3001',
});

GlobalApiClient.interceptors.request.use(async (config) => {
  const user = await userManager.getUser();
  const accessToken = user?.access_token;

  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `${accessToken}`,
      authtype: 'fusionauth',
    };
  }

  return config;
});
